import { useMutation } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { LoginNextResponse } from "@/types/auth";

/**
 * Signs the user out by calling `POST /api/auth/logout` (which clears every
 * auth cookie server-side) and then full-reloads to the next URL the server
 * returns — typically `/login`.
 *
 * Full reload (rather than `navigate()`) so the React Query cache, in-memory
 * session context, and any module-level state all reset to the unauthenticated
 * baseline. The login page is a public route outside `<AppShell>`, so it
 * doesn't depend on a fresh session being in cache.
 */
export function useLogout() {
  return useMutation({
    mutationFn: () => api.post<LoginNextResponse>("/api/auth/logout"),
    onSuccess: (response) => {
      window.location.assign(response.next);
    },
  });
}
